import http from '@/utils/http' //引入axios
export const getAd = data => http.get('/file-center/api/ad', {
    params: data
}) //查找ad
export const editAd = data => http.put('/file-center/api/ad',
    data
) //修改ad
export const addAd = data => http.post('/file-center/api/ad',
    data
) //添加ad
export const deleteAd = data => http.delete('/file-center/api/ad', {
    params: data
}) //刪除ad
export const download = data => http.get('/file_server/api/ad/download', {
    params: data
})
export default {
    getAd,
    editAd,
    addAd,
    deleteAd,
    download
}